module.exports = __webpack_public_path__ + "img/icon-tit_arrow.aa4fa63b.png";